import { useContext } from 'react';
import { StaffAugmentationReportContext } from '../Contexts/StaffAugmentationReportContext';

export const useStaffAugmentationReport = () =>
  useContext(StaffAugmentationReportContext);
